import React from 'react';
export const Series = (props) => {

    const image = (!props.image) ? 'http://thechurchco.com/wp-content/themes/church/assets/img/default-postcard.jpg' : props.image;
    const handleClick = (e) => {
        e.preventDefault();
        props.onClick(props.id)
    }
    return (
        <div className="row-column column-four image-type-landscape">
            <div className="row-column-wrap">
                <div className="image"><a href="#" onClick={handleClick}><img src={image} /></a></div>
                <div className="column-text">
                    <h6 dangerouslySetInnerHTML={{__html: props.name}} />
                    {props.description && (<p dangerouslySetInnerHTML={{__html: props.description}} />)}
                </div>
            </div>
        </div>
    )
}